module.exports = __webpack_public_path__ + "static/img/shangbiaozhuanrang.376bf440.png";